/**
 * WLatestNews — polskie tłumaczenia (widget najnowszych aktualności).
 *
 * Tytuły/zajawki newsów pochodzą z backendu (per locale, admin edytuje w
 * c_news). Tu stringi chrome widgetu + lokalny formatter daty.
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  empty: "Brak aktualności w tej sekcji.",
  readMore: "Czytaj więcej",
  watchAll: "Zobacz wszystkie",
  /** `formatDate("2026-05-13")` -> "13 maja 2026". */
  formatDate: (iso: string): string => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca",
      "lipca", "sierpnia", "września", "października", "listopada", "grudnia",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
} as const;

export type WLatestNewsTranslations = DeepString<typeof pl>;
